import { render } from "./ProductsProductThumbnails.vue?vue&type=template&id=078dd5a6"
import script from "./ProductsProductThumbnails.vue?vue&type=script&lang=js"
export * from "./ProductsProductThumbnails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__